import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { ROUTE_PATH } from '../constants/route-constants';
import { sendWebviewEvent } from '../utils/helpers/webview-event';
import checkLogin from '../utils/login/checkLogin';
import { WEB_VIEW_EVENTS } from '../constants/app-constants';
import { parseLocationSearchParams } from '../utils/helpers/parse-location-search-params';
import getAccessToken from '../utils/helpers/get-access-token';

const AuthenticationRoute = () => {
    const location = useLocation();
    const params = parseLocationSearchParams(location.search);
    const { token } = params;
    
    let isAuthenticated = checkLogin();
    
    // If there's a token in URL, allow access while validation is in progress
    // The AppConfigurations component will handle the validation and redirect if needed
    const hasTokenInUrl = !!token;
    
    useEffect(() => {
        if (isAuthenticated) {
            const accessToken = getAccessToken();
            sendWebviewEvent({ token: accessToken, type: WEB_VIEW_EVENTS.AUTH_TOKEN });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);

    // Allow access if authenticated OR if token is present in URL (validation in progress)
    return (isAuthenticated || hasTokenInUrl) ? <Outlet /> : <Navigate to={ROUTE_PATH.LOGIN} />;
};

export default AuthenticationRoute;
